import PromoTileWrapper from "../PromoTileWrapper";
import PropTypes from "prop-types";
import {
  FLOOR_MEN,
  FLOOR_WOMEN
} from "../../../../../state/modules/config/constants";
import styles from "./PromoTile.css";

const config = {
  COM: {
    translations: {
      new_here: "New here?",
      get_15_off: "Get 15% off most of ASOS!",
      code: "With code: HIFRIEND",
      shop_now: "Shop now",
      tnc: "Ts&Cs apply."
    },
    FLOOR_TO_URL_MAPPING: {
      [FLOOR_MEN]:
        "https://www.asos.com/men/new-in/cat/?cid=27110#ctaref-plp-tile",
      [FLOOR_WOMEN]:
        "https://www.asos.com/women/new-in/cat/?cid=27108#ctaref-plp-tile"
    }
  },
  US: {
    translations: {
      new_here: "New here?",
      get_15_off: "Get 15% off most of ASOS!",
      code: "With code: ASOSNEW",
      shop_now: "Shop now",
      tnc: "Ts&Cs apply."
    },
    FLOOR_TO_URL_MAPPING: {
      [FLOOR_MEN]:
        "https://www.asos.com/us/men/new-in/cat/?cid=27110#ctaref-plp-tile",
      [FLOOR_WOMEN]:
        "https://www.asos.com/us/women/new-in/cat/?cid=27108#ctaref-plp-tile"
    }
  },
  FR: {
    translations: {
      new_here: "TU VIENS D'ARRIVER?",
      get_15_off: "Profite de -15 % sur presque tout ASOS!*",
      code: "Avec le code: HELLOASOS",
      shop_now: "Shopper",
      tnc: "Voir conditions."
    },
    FLOOR_TO_URL_MAPPING: {
      [FLOOR_MEN]:
        "https://www.asos.com/fr/homme/nouveau/cat/?cid=27110#ctaref-plp-tile",
      [FLOOR_WOMEN]:
        "https://www.asos.com/fr/femme/nouveau/cat/?cid=27108#ctaref-plp-tile"
    }
  },
  DE: {
    translations: {
      new_here: "NEU HIER?",
      get_15_off: "Hol dir 15% auf fast alles bei ASOS!*",
      code: "Mit dem Code: HELLOASOS",
      shop_now: "Jetzt shoppen",
      tnc: "Es gelten die AGB."
    },
    FLOOR_TO_URL_MAPPING: {
      [FLOOR_MEN]:
        "https://www.asos.com/de/herren/neu-in/cat/?cid=27110#ctaref-plp-tile",
      [FLOOR_WOMEN]:
        "https://www.asos.com/de/damen/neu-in/cat/?cid=27108#ctaref-plp-tile"
    }
  }
};

const PromoTile = ({ storeCode, floor }) => {
  const {
    translations: { new_here, get_15_off, code, shop_now, tnc },
    FLOOR_TO_URL_MAPPING
  } = config[storeCode];
  const linkUrl = FLOOR_TO_URL_MAPPING[floor];

  return (
    <PromoTileWrapper linkUrl={linkUrl}>
      <div className={styles.promoTile}>
        <div className={styles.new_here}>{new_here}</div>
        <div>
          <div className={styles.get_15_off}>{get_15_off}</div>
          <div className={styles.code}>{code}</div>
        </div>
        <div className={styles.shop_now_wrapper}>
          <div className={styles.shop_now}>{shop_now}</div>
          <div className={styles.tnc}>{tnc}</div>
        </div>
      </div>
    </PromoTileWrapper>
  );
};

PromoTile.propTypes = {
  storeCode: PropTypes.string.isRequired,
  floor: PropTypes.string.isRequired
};

export default PromoTile;
